import {fabric} from "fabric";
import {getLockValue, getSettingsDataInstance, removeObjectFromCanvas, unFocusObjects} from "@frontend/utils";
import {
  ADDITIONAL_RECTANGLE_PREFIX_ID,
  ADDITIONAL_SAFE_ZONE_PREFIX_ID,
  SAFE_ZONE_PREFIX_ID
} from "@frontend/constants/templates-field-prefixes";
import {FIELD_TYPE_SAFE_ZONE} from "@frontend/constants/type-fields-of-template";
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
import {scaleControlsCornerSize} from "@frontend/constants/fabric-constants";

const SAFE_ZONE_DEFAULT_VALUES = {
  OPACITY: 0.2,
  FILL_COLOR: '#000000',
  STROKE_WIDTH: 0,
  ORDER: 99999
}

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export const drawAdditionalSafeZone = ({
  canvas,
  id,
}) => {
  unFocusObjects();

  removeObjectFromCanvas(canvas, ADDITIONAL_SAFE_ZONE_PREFIX_ID)

  const { canvas_data } = getScopePage();

  const settingsTemplate = getSettingsDataInstance(canvas_data[id]._data?.settings_template);

  canvas_data[id].additionalSafeZones.forEach((elementId, index) => {
    const x = parseInt(canvas_data[id]._data[`${elementId}_offset_x`]);
    const y = parseInt(canvas_data[id]._data[`${elementId}_offset_y`]);
    let width = parseInt(canvas_data[id]._data[`${elementId}_width`]);
    let height = parseInt(canvas_data[id]._data[`${elementId}_height`]);
    const opacity = parseFloat(canvas_data[id]._data[`${elementId}_opacity`]) || SAFE_ZONE_DEFAULT_VALUES.OPACITY;
    const fillColor = canvas_data[id]._data[`${elementId}_fill_color`] || SAFE_ZONE_DEFAULT_VALUES.FILL_COLOR;
    const strokeWidth = parseInt(canvas_data[id]._data[`${elementId}_thickness`]) || SAFE_ZONE_DEFAULT_VALUES.STROKE_WIDTH;
    const strokeColor = canvas_data[id]._data[`${elementId}_stroke_color`];
    const visible = canvas_data[id]._data[`${elementId}_visible`] ?? true;
    const objectId = ADDITIONAL_SAFE_ZONE_PREFIX_ID + index;
    
    if (strokeWidth && !isNaN(+strokeWidth)) {
      width -= +strokeWidth
      height -= +strokeWidth
    }

    const safeZone = new fabric.CustomRect({
      id: objectId,
      element_id: elementId,
      order: SAFE_ZONE_DEFAULT_VALUES.ORDER,
      top: y,
      left: x,
      width: width,
      height: height,
      opacity: opacity,
      fieldType: FIELD_TYPE_SAFE_ZONE,
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth,
      locked: getLockValue(id, elementId),
      selectable: true,
      evented: true,
      selectableBordersOnly: true,
      visible: visible,
      strokeUniform: true,
      name: settingsTemplate.getNameById(objectId, 'Additional Safe Zone ' + (index + 1)),
      link: settingsTemplate.getLinkById(objectId, ''),
    });

    scaleControlsCornerSize(safeZone);

    canvas.add(safeZone);
  });
}
